<template>
    <QualificationField :title="$t('profile.vetting.community.comments.title')" data-testid="admin-section-tabs-qualification-engagement-comment">
        <TextField
            class="engagement-comment"
            :content="profileQualificationStore.qualificationUpdateForm.engagementComment"
            :replace-by="$t('profile.vetting.community.comments.empty.placeholder')"
            data-testid="vetting-engagement-comment"
        />
    </QualificationField>
</template>

<script setup lang="ts">
    import TextField from '~/components/admin-section-tabs/qualification/TextField.vue';
    import {useProfileQualificationStore} from '~/store/profileQualificationStore';
    import QualificationField from './ui/QualificationField.vue';

    const profileQualificationStore = useProfileQualificationStore();
</script>

<style lang="scss" scoped>
    .engagement-comment {
        white-space: pre-wrap;
        font-size: var(--joy-font-size-primary-300);
    }
</style>
